import { render, staticRenderFns } from "./WaterWidget.vue?vue&type=template&id=4960cbf1&scoped=true&"
import script from "./WaterWidget.vue?vue&type=script&lang=js&"
export * from "./WaterWidget.vue?vue&type=script&lang=js&"
import style0 from "./WaterWidget.vue?vue&type=style&index=0&id=4960cbf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4960cbf1",
  null
  
)

export default component.exports